import { useGetBackProcedimentiIdEndoprocedimenti } from '@framework/api-client';
import { SelectInput } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import * as React from 'react';
import { useMemo } from 'react';
import { useCommunicationsContext } from '../../context/CommunicationsContext';

export interface ICommunicationSubprocedureSelectInputProps {
  name: string;
}

/**
 * Permette di scegliere l'ufficio per la comunicazione
 * all'endoprocedimento.
 */
export function CommunicationSubprocedureSelectInput(
  props: ICommunicationSubprocedureSelectInputProps,
) {
  const { name } = props;

  // Recupero l'id del procedimento dal contesto
  const { procedureId } = useCommunicationsContext();
  const { t } = useTranslation();

  const { data: subprocedures, isLoading } =
    useGetBackProcedimentiIdEndoprocedimenti(procedureId!, {
      query: { enabled: procedureId != null },
    });

  const options = useMemo(() => {
    return (subprocedures?.data ?? []).map(subprocedure => ({
      // Costruisco la label con il nome del tipo di procedimento, il numero
      // e il nome dell'ufficio di avvio.
      label: `${subprocedure.tipologiaProcedimento?.nomeTipo ?? 'N/A'} N.${
        subprocedure.numero ?? ''
      } (${subprocedure.nomeUfficioAvvio ?? 'N/A'})`,
      value: subprocedure.id!,
    }));
  }, [subprocedures]);

  // Non mostro nulla se non ho l'id del procedimento. Più per fallback che
  // altro, dato che su Backoffice è sempre valorizzato.
  if (!procedureId) {
    return null;
  }

  return (
    <SelectInput
      size="small"
      style={{ width: '350px' }}
      popupMatchSelectWidth={false}
      placeholder={t(
        'communications.select-receiver-subprocedure',
        'Seleziona endoprocedimento destinatario',
      )}
      name={name}
      allowClear
      showSearch
      loading={isLoading}
      options={options}
    />
  );
}
